<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="エクストラサイト設定参照(Type1、イントラネットFW)"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="mb-3">
              <v-col class="d-flex flex-row ga-2 justify-end">
                <v-btn color="primary" @click="toChange">変更</v-btn>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col>
                <app-label-group label="サイト名" :value="extraSite.siteName" />
              </v-col>
            </v-row>
            <app-table
              :fields="extraData.fields"
              :items="extraData.items"
              primary-key="ipAddressId"
              :tr-class="() => undefined"
              density="compact"
            >
              <!-- アドレス名-->
              <template #cell(ipAddressName)="data">
                {{ data.value || "-" }}
              </template>
              <!-- ゾーン配置-->
              <template #cell(zoneId)="data">
                {{ data.value ? "配置済" : "未配置" }}
              </template>
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import type {
  PutType1InternetAddress,
  Type1SiteEdit,
  Type1Zone,
} from "@/apis/Type1SiteApi";
import { defineComponent } from "vue";
import type { AppTableHeader } from "@/components/AppTable.vue";
import { VueFinalModal } from "vue-final-modal";
import ExtraSiteEdit from "@/modals/type1/ExtraSiteEdit.vue";

export default defineComponent({
  name: "ExtraSiteReference",
  props: {
    extraSite: {
      type: Object as PropType<Type1SiteEdit>,
      required: true,
    },
    extraZone: {
      type: Object as PropType<Type1Zone | null>,
      default: null,
    },
    type1SiteZoneKeyId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      extraData: {
        fields: [
          {
            key: "ipAddressName",
            title: "アドレス名",
          },
          {
            key: "ipAddress",
            title: "アドレス",
          },
          {
            key: "zoneId",
            title: "ゾーン配置",
          },
        ] as AppTableHeader<PutType1InternetAddress>[],
        items: [] as PutType1InternetAddress[],
      },
    };
  },
  async mounted() {
    await this.load();
  },
  methods: {
    /** 初期化機能 */
    async load() {
      this.extraData.items = this.extraSite.addressList;
    },
    /** 変更機能 */
    async toChange() {
      await this.$modal.show(ExtraSiteEdit, {
        extraSite: this.extraSite,
        extraZone: this.extraZone,
        type1SiteZoneKeyId: this.type1SiteZoneKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
